module.exports = __webpack_public_path__ + "img/empty_default.ee249803.png";